import React, { useState } from 'react';
import BottomNavigationScreen from '../Navigation/Bottom';
import { StepperBar } from '../Tabs';
import { useSelector } from 'react-redux';
import { Box, CssBaseline } from '@mui/material';
import { useAuth, useConfirm, usePrompt } from '../../../hooks';
import { Loader } from '../../../Components';
import { CableTieQrScreen, LogisticsQrCodeScan } from './Qr';
import { LogisticsSignature } from './Signature';
import SampleCollected from './CollectedSamples';
import PickupDetailsScreen from './PickupDetails';
import { isMalaysian } from '../../../utils';

const CollectOrderStepsScreen = () => {
  const user = useSelector((state) => state.userReducer.user);
  const checkInId = useSelector((state) => state.practicesReducer.checkInId);
  const [step, setStep] = useState(checkInId || isMalaysian(user?.country) ? 2 : 1);
  const [enroutedPractice] = useSelector(
    (state) => state.practicesReducer.enroutedPractices
  );
  const loading = useSelector((state) => state.practicesReducer.loading);
  const { isConfirmed } = useConfirm();

  const handleClickCancel = async (next) => {
    return await isConfirmed(next);
  };

  useAuth(); // Authorization Hook

  usePrompt(
    true,
    step > (isMalaysian(user?.country) ? 2 : 1) && step < 5, 
    handleClickCancel, 
    user
  );

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          bgcolor: step < 5 && '#FAFAFA',
          gap: '10px',
        }}
      >
        <Box
          sx={{ width: '100%', boxShadow: '0px 0px 8px 1px rgb(0 0 0 / 20% )' }}
        >
          <StepperBar
            step={step}
            practiceName={enroutedPractice?.name}
            urgentOrders={enroutedPractice?.orders_count.urgent_orders}
          />
        </Box>

        <Box sx={{ flex: 1, overflow: 'auto' }}>
          {/* Now we will render steps conditionally based on country */}
            <>
              {step === 1 && (
                <LogisticsQrCodeScan
                  enroutedPractice={enroutedPractice}
                  setStep={setStep}
                />
              )}
              {step === 2 && (
                <PickupDetailsScreen
                  user={user}
                  enroutedPractice={enroutedPractice}
                  setStep={setStep}
                  loading={loading}
                />
              )}
              {step === 3 && <CableTieQrScreen setStep={setStep} />}
              {step === 4 && (
                <LogisticsSignature
                  user={user}
                  enroutedPractice={enroutedPractice}
                  setStep={setStep}
                />
              )}
              {step === 5 && (
                <SampleCollected enroutedPractice={enroutedPractice} />
              )}
            </>
        </Box>
        {loading && <Loader loading={loading} />}
        <Box>
          <BottomNavigationScreen />
        </Box>
      </Box>
    </>
  );
};
export default CollectOrderStepsScreen;
